import React from "react";
import styled, { css } from "styled-components";
import PropTypes from "prop-types";

// context
import { useSiteHeader } from "core/SiteHeader/context/useSiteHeader.js";

// data
import { primaryMenu } from "data/links";
import { trackHeaderPricingClicked } from "core/trackEvent.js";

// components
import Link, { AnchorStyled } from "./Link.js";

// styles
import colors from "core/colors";
import { bold as boldFontWeight } from "core/fontStyles";
import { convertPxToRem } from "frontend/components/helpers";

const PricingLinkStyled = styled(Link)`
    border: none;
    margin: 0rem ${convertPxToRem(16)} 0rem 0rem;

    ${AnchorStyled} {
        ${boldFontWeight}
        color: ${colors.accent.lightMode.persian};
        &:hover {
            color: ${colors.accent.lightMode.pansy};
            text-decoration: none;
            border-bottom-color: transparent;
        }

        ${({ $isDarkMode }) => {
            if ($isDarkMode) {
                return css`
                    color: ${colors.accent.darkMode.suenosBuenos};
                    &:hover {
                        color: ${colors.accent.darkMode.surf};
                        border-bottom-color: transparent;
                    }
                `;
            }
        }}
    }
`;

// component
export const PricingLink = ({ onFocus, isDisabled = false }) => {
    const { isDarkMode } = useSiteHeader();
    const { pricing } = primaryMenu.products.links;
    return (
        <PricingLinkStyled
            link={pricing}
            $isDarkMode={isDarkMode}
            onFocus={onFocus}
            isDisabled={isDisabled}
            onMouseDown={pricing.track}
        />
    );
};

export default PricingLink;

// prop-types
PricingLink.propTypes = {
    onFocus: PropTypes.func,
    isDisabled: PropTypes.bool
};
